import React from "react";

interface BrandImportPreviewTableProps {
  headers: string[];
  previewData: Record<string, unknown>[];
}

export const BrandImportPreviewTable: React.FC<BrandImportPreviewTableProps> = ({
  headers,
  previewData,
}) => {
  if (previewData.length === 0) return null;

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium">Preview (First 5 Rows)</h3>
      <div className="border rounded-lg overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 border-b">
            <tr>
              {headers.map((header) => (
                <th key={header} className="px-4 py-2 text-left font-medium text-gray-900">
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {previewData.map((row, index) => (
              <tr key={index} className="border-b">
                {headers.map((header) => (
                  <td key={header} className="px-4 py-2 text-gray-700">
                    {String(row[header] ?? '—')}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
